/**
 * Connection Enricher Middleware
 * Adds network quality classification
 */

import type { Middleware, CollectedEvent } from '../types.js';

export class ConnectionEnricher implements Middleware {
  name = 'connection-enricher';

  onPostCollect(event: CollectedEvent): CollectedEvent {
    // Add connection quality classification
    let connectionQuality: 'excellent' | 'good' | 'fair' | 'poor' | 'unknown' = 'unknown';

    if (event.connection_type) {
      switch (event.connection_type) {
        case '4g':
          connectionQuality = 'excellent';
          break;
        case '3g':
          connectionQuality = 'good';
          break;
        case '2g':
          connectionQuality = 'fair';
          break;
        case 'slow-2g':
          connectionQuality = 'poor';
          break;
      }
    } else if (event.connection_rtt !== null) {
      // Classify by RTT if type not available
      if (event.connection_rtt < 100) {
        connectionQuality = 'excellent';
      } else if (event.connection_rtt < 300) {
        connectionQuality = 'good';
      } else if (event.connection_rtt < 1000) {
        connectionQuality = 'fair';
      } else {
        connectionQuality = 'poor';
      }
    }

    return {
      ...event,
      connection_quality: connectionQuality
    };
  }
}

